<script>
    import timeout from './timeout.js';
    import dispatcher from './dispatch.js'; const dispatch = dispatcher();
    import { setContext } from 'svelte';
    let state = "normal";
    let div = null;
    setContext('dispatch', (e) => {
        console.log('FadeOnNav message:' + JSON.stringify(e));
        if (e.dest == null) {
            // pass-through events with no navigation
            dispatch(e);
        } else {
            if (state == 'fading') {
                // ignore event
            } else { // if (state === 'normal')
                // disable navigation
                state = 'fading';
                // fade out
                div && div.animate({opacity: 0}, 300).finished.then(() => {
                    // navigate
                    dispatch(e);
                    // fade back in
                    div && div.animate({opacity: 0, offset: 0}, 300).finished.then(() => {
                        state = 'normal';
                    });
                });
            }
        }
    });
</script>


<div bind:this={div}>
    <slot/>
</div>